import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="footer padded-sec"> 
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-3 col-lg-6 col-sm-12 col-xs-12'>
              <Link to="/"><div className='ftr-logo'> 
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/ftr-logo.png" alt="MMATD" /> </LazyLoad>
                <div className="subscribe-box"> 
                    <div className="input-group">
                        <input type="email" className="form-control" placeholder="marymathacmi@yahoo.com"/>
                        <span className="input-group-btn">
                          <button className="btn" type="submit">MAIL US</button>
                        </span>
                    </div>
                  </div>
               <div className='socialMedia'>
                 <h6>FOLLOW US ON</h6>
                  <ul>    
                    <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/yt.png" alt="MMATD" /></Link></li> 
                    <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/facebook.png" alt="MMATD" /></Link></li> 
                    <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/instagram.png" alt="MMATD" /></Link></li>
                  </ul>
              </div>
              </div>
              </Link>
            </div> 
            <div className='col-xl-2 col-lg-6 col-sm-6 col-xs-12'>
              <h3>Quick Links</h3>
              <div className='quick-link'>
                <ul>
                  <li><Link to="/AboutUs"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/listicn.png" alt="MMATD"/> About Us</Link></li> 
                  <li><Link to="/"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/listicn.png" alt="MMATD"/> Alumni</Link></li>
                  <li><Link to="/ContactUs"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/listicn.png" alt="MMATD"/> Contact Us </Link></li>
                  <li><Link to="/ErpSoftware"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/listicn.png" alt="MMATD"/> ERP Software</Link></li>
                  <li><Link to="https://portalguidelines.campuscare.info/index.html#MMCMIA" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/listicn.png" alt="MMATD"/>   Portal (Help?)</Link></li>
                  <li><Link to="/Tc"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/listicn.png" alt="MMATD"/> Transfer Certificate</Link></li>
                </ul>
              </div>
            </div>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12 address'>
              <h3>Locate us</h3>
              <p><i class="bi bi-geo-alt-fill"></i> <span><Link to="/" target="_blank">D.No. 224/B, Perumalkoilpatti, Devadanapatti, Periyakulam Taluk,
              Theni – 625602, Tamilnadu.</Link></span></p>
              <p><i className="bi bi-telephone-fill"></i> <span><a href="tel:+918056851655">Mob :+918056851655,</a> <br/>
               <a href="tel:+918015471655"> Mob :+91 8015471655</a></span></p> 
            
              </div>
            <div className='col-xl-4 col-lg-6 col-sm-12 col-xs-12'>
              <div className='ph-flex'>
                <div className="app-cont">
                  <h3>Download Mobile App</h3>
                  <p>  CampusCare 10x mobile app for parents is a tool that serves as a single point of reference for parents. The app centralises all the school-parent interaction and lets parents stay updated with their ward's day-to-day activities. Parents can receive assignments, homework, and circulars, keep track of their child's attendance, do online fee payment, view report cards.</p>
                  <div>
                    <a href="https://apps.apple.com/in/app/campuscare-10x/id1611283814" target="_blank">
                      <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/apple.png" className="img-fluid" /></LazyLoad>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.entab.learninglab&amp;hl=en-IN" target="_blank">
                      <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/playstore.png" className="img-fluid" /></LazyLoad>
                    </a>
                  </div>
                  <p className="link"><Link to="https://entab.online/MMCMIA" target="_blank">School Code : MMCMIA</Link></p>
                </div>
                <div className='mobile-icon'>
                  <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/mobile-icon.png" className="img-fluid" /></LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='copyright'>
        ©️ Copyright 2025 by  Mary Matha CMI Academy, Theni | Created By   <Link to="https://www.entab.in/" target="_blank">Entab Infotech: CampusCare®️ </Link>
      </div>
    </>
  );
}

export default Footer;
